export default __webpack_public_path__ + "static/media/customer08.6b1b3d6f.jpg";